import dayjs from 'dayjs';

export const DEFAULT_QUALITY_CONTROL_NOTICE_FILTERS = {
  startTime: dayjs().subtract(1, 'month').startOf('day').format('YYYY-MM-DD'),
  endTime: dayjs().endOf('day').format('YYYY-MM-DD'),
  registrationNumber: '',
};